<template>
  <v-container fluid class="pa-0 fill-height">
    <navigation :color="color" :flat="flat" />
    <v-main class="pa-0">
      <home />
      <about />
      <propiedades />
      <asesores />
      <contact />
    </v-main>
    <v-scale-transition>
      <v-btn
        fab
        v-show="fab"
        v-scroll="onScroll"
        dark
        fixed
        bottom
        right
        color="secondary"
        @click="toTop"
      >
        <v-icon>mdi-arrow-up</v-icon>
      </v-btn>
    </v-scale-transition>
    <foote />
  </v-container>
</template>

<script>
import navigation from "./Navigation";
import foote from "./Footer";
import home from "./HomeSection";
import about from "./AboutSection";
import propiedades from "./DownloadSection";
import asesores from "./AsesoresSection";
import contact from "./ContactSection";

export default {
  name: "HomePage",
  components: {
    navigation,
    foote,
    home,
    about,
    propiedades,
    asesores,
    contact,
  },
  data: () => ({
    fab: null,
    color: "",
    flat: null,
  }),
  created() {
    const top = window.pageYOffset || 0;
    if (top <= 60) {
      this.color = "transparent";
      this.flat = true;
    }
  },
  watch: {
    fab(value) {
      if (value) {
        this.color = "secondary";
        this.flat = false;
      } else {
        this.color = "transparent";
        this.flat = true;
      }
    },
  },
  methods: {
    onScroll(e) {
      if (typeof window === "undefined") return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.fab = top > 60;
    },
    toTop() {
      this.$vuetify.goTo(0);
    },
  },
};
</script>

<style scoped>
html, body, #app {
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
  overflow: hidden;
}

.v-container {
  margin: 0 !important;
  padding: 0 !important;
  width: 100%;
  min-height: 100vh;
  overflow: hidden;
}

.v-main {
  margin: 0 !important;
  padding: 0 !important;
  background-image: url("~@/assets/img/bgMain.png");
  background-attachment: fixed;
  background-position: center;
  background-size: cover;
  min-height: calc(100vh - 64px); /* Ajustar para evitar el doble scroll */
}

.v-footer {
  background-color: transparent !important;
  box-shadow: none !important;
  margin: 0;
  padding: 0;
}
</style>